module.exports = __webpack_public_path__ + "static/h-hero-3-8171703f821ad84a626c94c0fffac8fa.jpg";